<template>
  <common-dialog ref="dialog" :title="title" width="1200px" :in-dialog="inDialog">
    <list
      row-key="Id"
      ref="list"
      unit="商品上架"
      :page="page"
      :query-params="params"
      :show-checkbox="multiple"
      :show-query="showQuery"
      :get-data-func="api.sellGoods"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="商品名称">
          <el-input v-model="params.GoodsName" placeholder="请输入商品名称" clearable />
        </el-form-item>
        <el-form-item label="展示分类">
          <!-- <el-input  v-model="params.MallClassIdChain" placeholder="请输入展示分类"  clearable /> -->
          <select-mall ref="selectMall" v-model.trim="params.MallClassIdChain" />
        </el-form-item>
        <el-form-item label="商品分类">
          <!-- <el-input  v-model="params.ClassIdChain" placeholder="请输入商品分类" clearable /> -->
          <select-class ref="selectClass" v-model.trim="params.ClassIdChain" />
        </el-form-item>
        <!-- <el-form-item label="上架状态">
          <el-select v-model="params.MallStatus" placeholder="请选择上架状态" clearable>
            <el-option label="待上架" :value="0"></el-option>
            <el-option label="上架" :value="1"></el-option>
            <el-option label="下架" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="params.Status" placeholder="请选择状态" clearable>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item> -->
      </template>
      <template slot="table">
        <el-table-column prop="GoodsName" label="商品名称" min-width="110px" />
        <el-table-column prop="MallClassName" label="展示分类" min-width="100px" />
        <el-table-column prop="ClassName" label="商品分类" min-width="110px" />
        <el-table-column prop="Thumbnail" label="商品图片" min-width="110px" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 80px; height: 80px" :src="'/api'+row.Thumbnail" fit="fill"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="IsPickSelf" label="支持自提" min-width="110px">
          <template slot-scope="{row}">{{row.IsPickSelf?'是':'否'}}</template>
        </el-table-column>
        <el-table-column prop="Model" label="规格型号" min-width="110px" />
        <el-table-column prop="SaleUnitName" label="销售单位" min-width="100px" />
        <el-table-column prop="RetailPrice" label="零售价" min-width="110px" />
        <!-- <el-table-column prop="RetailPrice2" label="零售价2" min-width="100px" /> -->
        <!-- <el-table-column prop="RetailPoint" label="批发价1" min-width="110px" /> -->
        <!-- <el-table-column prop="RetailPoint2" label="批发价2" min-width="100px" /> -->
        <el-table-column prop="MallStatus" label="状态" width="80px" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.MallStatus==0" type="warning">待上架</el-tag>
            <el-tag v-else-if="row.MallStatus==1" type="success">上架</el-tag>
            <el-tag v-else type="danger">下架</el-tag>
          </template>
        </el-table-column>
        <template v-if="selectable&&!multiple">
          <el-table-column label="操作" align="center" width="60" fixed="right">
            <template slot-scope="{row}">
              <el-button @click="onSelect(row)" type="text">选择</el-button>
            </template>
          </el-table-column>
        </template>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple" v-if="selectable&&multiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import commonDialog from "@/components/common/dialog";
import listDialogMixins from "@/mixins/listDialog";
import selectClass from "@/components/basicinfo/basic/ent/classselect";
import selectMall from "@/components/basicinfo/basic/ent/mallclassSelect";

export default {
  components: { commonDialog, list, selectClass, selectMall },
  mixins: [listDialogMixins, listMixin],
  props: {
    title: {
      type: String,
      default: "商城商品列表",
    },
  },
  data() {
    return {
      api: require("@/api/mall/mallgoods").default,
      params: {
        GoodsName: "", //商品名称
        MallClassIdChain: "", //展示分类
        ClassIdChain: "", //商品分类
        Status: null,
        MallStatus: null, //0：待上架；1：上架；2：下架
      },
    };
  },
  methods: {},
};
</script>